import { createClient } from '@supabase/supabase-js';
import { supabaseDefaultConfig } from './config';
// Create a single, shared Supabase client for the browser
export const supabase = createClient(import.meta.env.VITE_SUPABASE_URL, import.meta.env.VITE_SUPABASE_ANON_KEY, {
    ...supabaseDefaultConfig,
});
//# sourceMappingURL=client.js.map